// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  padding: var(--spacing-large);
}

.title-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-small);
}

.wide {
  width: 310px;
}

.wider {
  width: 640px;
}

.flex-line {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-medium);
}

.error {
  margin-top: var(--spacing-medium);
  color: var(--color-red);
}

mat-form-field {
  margin-bottom: var(--spacing-medium);
}

mat-progress-bar {
  margin-bottom: var(--spacing-small);
}

.search-form {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  gap: var(--spacing-medium);
}
.search-form .search {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/crud.common.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mCAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,0BAAA;AACF;;AAEA;EACE,iCAAA;EACA,uBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAGA;EACE,mCAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,0BAAA;AAAF;AAEE;EACE,YAAA;AAAJ","sourcesContent":[":host {\n  display: block;\n  padding: var(--spacing-large);\n}\n\n.title-line {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-small);\n}\n\n.wide {\n  width: 310px;\n}\n\n.wider {\n  width: 640px;\n}\n\n.flex-line {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-medium);\n}\n\n.error {\n  margin-top: var(--spacing-medium);\n  color: var(--color-red);\n}\n\nmat-form-field {\n  margin-bottom: var(--spacing-medium);\n}\n\n\nmat-progress-bar {\n  margin-bottom: var(--spacing-small);\n}\n\n.search-form {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: baseline;\n  gap: var(--spacing-medium);\n\n  .search {\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
